import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class DailyDollarRateService {
  response: Observable<any> | null = null
  url: string | null = null
  constructor (private http: HttpClient) {
    this.url = environment.baseApiUrl + 'admin/'
  }

  getAllDailyRates (page: string | number): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + `rates?per_page=10&page=${page}`
          : environment.baseApiUrlTest + `rates?per_page=10&page=${page}`
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  addNewRate (data: any): Observable<any> {
    this.response = this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'rate'
          : environment.baseApiUrlTest + 'rate',
        data
      )
      .pipe(
        map((response: any) => {
          // console.log(data);
          return response
        })
      )

    return this.response
  }

  getDetails (id: string): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + `rate-details/${id}`
          : environment.baseApiUrlTest + `rate-details/${id}`
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  approveRate (data: any): Observable<any> {
    this.response = this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'approve-rate'
          : environment.baseApiUrlTest + 'approve-rate',
        data
      )
      .pipe(
        map((response: any) => {
          // console.log(data);
          return response
        })
      )

    return this.response
  }

  getCurrentRate (): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + `daily-rate`
          : environment.baseApiUrlTest + `daily-rate`
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  editRate (data: any, id: string | number): Observable<any> {
    return this.http
      .patch(
        environment.production
          ? environment.baseApiUrl + 'edit-rate/' + id
          : environment.baseApiUrlTest + 'edit-rate/' + id,
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  deleteRate (id: string): Observable<any> {
    return this.http
      .delete(
        environment.production
          ? environment.baseApiUrl + 'delete-rate/' + id
          : environment.baseApiUrlTest + 'delete-rate/' + id
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }
}
